import { useRef } from "react";
import { Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { SnackbarKey, SnackbarProvider } from "notistack";
import { Route, Routes } from "react-router-dom";

import { AppLayout } from "../layout/AppLayout";
import { MapLayout } from "layout/MapLayout";
import { MapLayoutRightSideNav } from "layout/MapLayoutRightSideNav";

import { Outlet } from "components/navigation/Outlet";

import { DrawStudyAreaPage } from "./DrawStudyAreaPage";
import { ClimateEffectsPage } from "./ClimateEffectsPage";
import { MeasuresPage } from "./MeasuresPage";
import { AddMeasurePage } from "./AddMeasurePage";
import { UuidGuard } from "components/guards/UuidGuard";
import { SelectMeasurePage } from "./SelectMeasurePage";
import { ProgressPage } from "./ProgressPage";
import { ResultPage } from "./ResultPage";
import { ProgressIdGuard } from "components/guards/ProgressIdGuard";
import { ResultPrintPage } from "./ResultPrintPage";
import { JoyrideProvider } from "components/joyride/JoyrideProvider";
import { UploadMeasurePage } from "pages/UploadMeasurePage";
import { DrawOrUploadMeasurePage } from "pages/DrawOrUploadMeasurePage";

export function RootPage() {
  const notistackRef = useRef<SnackbarProvider | null>(null);

  function onClickDismiss(key: SnackbarKey) {
    if (notistackRef !== null && notistackRef.current !== null) {
      notistackRef.current.closeSnackbar(key);
    }
  }

  return (
    <SnackbarProvider
      maxSnack={3}
      ref={notistackRef}
      autoHideDuration={5000}
      action={(key: SnackbarKey) => (
        <IconButton onClick={() => onClickDismiss(key)} color="inherit">
          <Close />
        </IconButton>
      )}
    >
      <JoyrideProvider>
        <Routes>
          <Route path="/" element={<AppLayout />}>
            <Route path="*" element={<MapLayout />}>
              <Route index element={<DrawStudyAreaPage />} />
              <Route path=":uuid" element={<Outlet />}>
                <Route index element={<DrawStudyAreaPage />} />
              </Route>
            </Route>

            <Route path=":uuid" element={<UuidGuard />}>
              <Route path="*" element={<MapLayoutRightSideNav />}>
                <Route path="climate-effects" element={<Outlet />}>
                  <Route index element={<ClimateEffectsPage />} />
                </Route>

                <Route path="measures" element={<MeasuresPage />} />

                <Route path="measure" element={<Outlet />}>
                  <Route path="hardened-surface" element={<Outlet />}>
                    <Route path="select" element={<SelectMeasurePage />} />
                  </Route>

                  <Route path="adaptive-measure" element={<Outlet />}>
                    <Route path="select" element={<SelectMeasurePage />} />
                  </Route>

                  <Route path=":measureId" element={<Outlet />}>
                    <Route index element={<DrawOrUploadMeasurePage />} />
                    <Route path="upload" element={<UploadMeasurePage />} />
                    <Route path="group" element={<Outlet />}>
                      <Route index element={<AddMeasurePage />} />
                      <Route path=":groupId" element={<Outlet />}>
                        <Route index element={<AddMeasurePage />} />
                      </Route>
                    </Route>
                  </Route>
                </Route>
              </Route>
            </Route>

            <Route path=":uuid" element={<UuidGuard />}>
              <Route path="progress/:progressId" element={<ProgressIdGuard />}>
                <Route index element={<ProgressPage />} />
              </Route>
              <Route path="result" element={<ResultPage />} />
            </Route>
          </Route>
          <Route path=":uuid" element={<UuidGuard />}>
            <Route path="print" element={<ResultPrintPage />} />
          </Route>
        </Routes>
      </JoyrideProvider>
    </SnackbarProvider>
  );
}
